import React, { useState, useEffect } from "react";
import { baseApiUrl } from "../../../services/api";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import "./reaction.css";
import { notification } from 'antd'; // Import Ant Design notification
import { FaRegComment } from 'react-icons/fa';

function InfoProjet({ project, categoriesOptions }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [category, setCategory] = useState("Toutes");
  const [likesData, setLikesData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [likeCount, setLikeCount] = useState(0);
  const [dislikeCount, setDislikeCount] = useState(0);
  const [projects, setProjects] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [comment, setComment] = useState("");
  const [comments, setComments] = useState([]);
  const [showCommentModal, setShowCommentModal] = useState(false);

  const imageUrl = project.image
    ? baseApiUrl.defaults.baseURL + `/image/${project.image}`
    : "default-image.jpg";

  const navigate = useNavigate();

  const fetchLikeCounts = async (projectId) => {
    try {
      const response = await fetch(`${baseApiUrl.defaults.baseURL}/likes/projet/${projectId}`);
      if (response.ok) {
        const data = await response.json();
        setLikeCount(data.likeCount);
        setDislikeCount(data.dislikeCount);
      } else {
        console.error("Erreur lors de la récupération des compteurs !");
      }
    } catch (error) {
      console.error("Erreur réseau :", error);
    }
  };

  const fetchComments = async (entityId) => {
    try {
      // Utiliser l'URL correcte basée sur la documentation Swagger
      const response = await fetch(
        `${baseApiUrl.defaults.baseURL}/commentaire/projet/${entityId}/commentaires`
      );

      if (response.ok) {
        const data = await response.json();
        console.log("Commentaires récupérés:", data);
        setComments(data);
      } else {
        console.error("Erreur lors de la récupération des commentaires ! Code:", response.status);
        notification.error({
          message: "Erreur",
          description: "Impossible de récupérer les commentaires pour ce projet.",
          placement: "topRight"
        });
      }
    } catch (error) {
      console.error("Erreur réseau lors de la récupération des commentaires:", error);
      notification.error({
        message: "Erreur réseau",
        description: "Une erreur de connexion est survenue lors de la récupération des commentaires.",
        placement: "topRight"
      });
    }
  };

  const truncateText = (text, wordLimit) => {
    if (typeof text !== 'undefined' && text !== null) {
      const words = text.split(" ");
      if (words.length > wordLimit) {
        return words.slice(0, wordLimit).join(" ") + "...";
      }
      return text;
    } else {
      return '';
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setCurrentUser(decoded);
        console.log("Utilisateur connecté:", decoded);
      } catch (error) {
        console.error("Erreur lors du décodage du token:", error);
      }
    } else {
      console.warn("Aucun token trouvé dans localStorage.");
    }
  }, []);

  useEffect(() => {
    if (project && project.id) {
      fetchLikeCounts(project.id);
      fetchComments(project.id);
    }
  }, [project]);

  const getCategoryNameById = (id) => {
    if (!categoriesOptions) {
      console.error("categoriesOptions is undefined");
      return "Catégorie inconnue";
    }

    const category = categoriesOptions.find((cat) => cat.value === id);
    return category ? category.label : "Catégorie inconnue";
  };

  const goToProjectDetail = () => {
    if (project.id) {
      navigate(`/projet/${project.id}`);
    } else {
      console.error("L'ID du projet est indéfini !");
      notification.error({
        message: "Erreur",
        description: "Impossible d'accéder aux détails de ce projet.",
        placement: "topRight"
      });
    }
  };

  const calculateReadingTime = (text) => {
    if (!text) return 1;
    const wordCount = text.split(/\s+/).length;
    const minutes = Math.ceil(wordCount / 200);
    return minutes === 0 ? 1 : minutes;
  };

  const readingTime = calculateReadingTime(project.contenu);

  const handleLike = (projectId, isLiked) => {
    const typeEntity = "projet";
    let url;

    url = `${baseApiUrl.defaults.baseURL}/likes/${typeEntity}/${projectId}`;

    if (currentUser) {
      url += `?utilisateurId=${currentUser.id}&isLiked=${isLiked}`;
    } else {
      url += `?isLiked=${isLiked}`;
    }

    const token = localStorage.getItem("token");
    const headers = {
      "Content-Type": "application/json"
    };

    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    fetch(url, {
      method: "POST",
      headers: headers,
    })
      .then((response) => {
        if (response.ok) {
          console.log(`${isLiked ? "Like" : "Dislike"} ajouté avec succès pour le projet ${projectId}`);
          notification.success({
            message: "Succès",
            description: `Votre ${isLiked ? "j'aime" : "je n'aime pas"} a été enregistré.`,
            placement: "topRight"
          });
          fetchLikeCounts(projectId);
        } else {
          console.error("Erreur lors de l'ajout du like, code :", response.status);
          notification.error({
            message: "Erreur",
            description: "Une erreur est survenue lors de l'enregistrement de votre réaction.",
            placement: "topRight"
          });
        }
      })
      .catch((error) => {
        console.error("Erreur réseau :", error);
        notification.error({
          message: "Erreur réseau",
          description: "Une erreur de connexion est survenue.",
          placement: "topRight"
        });
      });
  };

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  const handleDislike = async (projectId, isLiked) => {
    const typeEntity = "projet";
    let url;

    url = `${baseApiUrl.defaults.baseURL}/likes/${typeEntity}/${projectId}`;

    if (currentUser) {
      url += `?utilisateurId=${currentUser.id}&isLiked=${isLiked}`;
    } else {
      url += `?isLiked=${isLiked}`;
    }

    const token = localStorage.getItem("token");
    const headers = {
      "Content-Type": "application/json"
    };

    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: headers,
      });

      if (response.ok) {
        console.log(`${isLiked ? "Like" : "Dislike"} ajouté avec succès pour le projet ${projectId}`);
        notification.success({
          message: "Succès",
          description: `Votre ${isLiked ? "j'aime" : "je n'aime pas"} a été enregistré.`,
          placement: "topRight"
        });
        fetchLikeCounts(projectId);
      } else {
        console.error(`Erreur lors de l'ajout du ${isLiked ? "like" : "dislike"} :`, response.status);
        notification.error({
          message: "Erreur",
          description: "Une erreur est survenue lors de l'enregistrement de votre réaction.",
          placement: "topRight"
        });
      }
    } catch (error) {
      console.error("Erreur réseau :", error);
      notification.error({
        message: "Erreur réseau",
        description: "Une erreur de connexion est survenue.",
        placement: "topRight"
      });
    }
  };

  const handleCommentSubmit = async (e) => {
    e.preventDefault();

    if (!currentUser) {
      notification.warning({
        message: "Authentification requise",
        description: "Vous devez être connecté pour commenter ce projet.",
        placement: "topRight"
      });
      return;
    }

    if (comment.trim() === "") {
      notification.warning({
        message: "Commentaire vide",
        description: "Veuillez saisir un commentaire avant de soumettre.",
        placement: "topRight"
      });
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      notification.warning({
        message: "Authentification requise",
        description: "Votre session a expiré. Veuillez vous reconnecter.",
        placement: "topRight"
      });
      return;
    }

    try {
      const url = `${baseApiUrl.defaults.baseURL}/commentaire/ajouter`;

      const queryParams = new URLSearchParams({
        entityId: project.id,         // ID du projet
        utilisateurId: currentUser.id, // ID de l'utilisateur
        typeEntity: "projet",          // Type d'entité (projet)
        comment: true                  // Indique qu'il s'agit d'un commentaire
      });

      const commentData = {
        id: 0,                        // ID 0 pour un nouveau commentaire
        message: comment,             // Message du commentaire
        statut: true,                 // Statut actif du commentaire
        utilisateur: {
          id: currentUser.id          // ID de l'utilisateur qui commente
        },
        projet: {
          id: project.id              // ID du projet commenté
        }
      };

      const response = await fetch(`${url}?${queryParams.toString()}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(commentData)
      });

      if (response.ok) {
        notification.success({
          message: "Succès",
          description: "Votre commentaire a été ajouté.",
          placement: "topRight"
        });
        setComment("");
        fetchComments(project.id);
      } else {
        console.error("Erreur lors de l'ajout du commentaire, code:", response.status);
        notification.error({
          message: "Erreur",
          description: "Impossible d'ajouter votre commentaire.",
          placement: "topRight"
        });
      }
    } catch (error) {
      console.error("Erreur réseau :", error);
      notification.error({
        message: "Erreur réseau",
        description: "Une erreur de connexion est survenue.",
        placement: "topRight"
      });
    }
  };

  const fetchReactions = async (projectId) => {
    try {
      const response = await fetch(`${baseApiUrl.defaults.baseURL}/likes/projet/${projectId}/reactions`);
      if (response.ok) {
        const data = await response.json();
        setLikesData(data);
        setShowModal(true);
        console.log("Réactions récupérées:", data);
      } else {
        console.error("Erreur lors de la récupération des réactions !");
        notification.error({
          message: "Erreur",
          description: "Impossible de récupérer les réactions pour ce projet.",
          placement: "topRight"
        });
      }
    } catch (error) {
      console.error("Erreur réseau :", error);
      notification.error({
        message: "Erreur réseau",
        description: "Une erreur de connexion est survenue lors de la récupération des réactions.",
        placement: "topRight"
      });
    }
  };

  const openCommentModal = () => {
    fetchComments(project.id);
    setShowCommentModal(true);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "Date inconnue";

    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (error) {
      console.error("Erreur de formatage de date:", error);
      return "Date invalide";
    }
  };

  return (
    <div className="col-md-4 g-4">
      <div className="blog1-single-box" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div
          className="thumbnail image-anime"
          onClick={goToProjectDetail}
          style={{ cursor: "pointer", flex: '1' }}
        >
          <img
            src={imageUrl}
            className="card-img-top"
            alt="Project Image"
            style={{
              width: "100%",
              height: "200px",
              objectFit: "cover",
              borderRadius: "10px",
            }}
          />
          <div className="heading1">
            <div className="social-area">
              <a href="/detail" className="social" style={{ backgroundColor: '#4CAF50', color: 'white' }}>
                {project? getCategoryNameById(project.categorieId) : "RAS"}
              </a>
              <a href="#" className="time">
                <img
                  src="assets/img/icons/time1.svg"
                  alt="vexon"
                  style={{ width: "16px", height: "16px" }}
                /> {readingTime} min
              </a>
            </div>

            <h4>
              <a style={{ color: "black", fontWeight: "bold" }} href="blog-single.html">
                {truncateText(project ? project.titre : "", 10)}
              </a>
            </h4>
            <p className="mt-16">{truncateText(project ? project.descriptionTechnique : "", 10)}</p>
            <div className="author-area">
              <div className="">
                <span>
                  <img
                    src="assets/img/icons/date1.svg"
                    alt="vexon"
                    style={{ width: "16px", height: "16px" }}
                  />
                  {project.created ? formatDate(project.created) : "Date inconnue"}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="like-dislike-buttons" style={{ marginTop: '15px', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: '10px' }}>
          <button
            onClick={() => handleLike(project.id, true)}
            className="btn"
            style={{ backgroundColor: '#4CAF50', color: 'white', flex: '1', minWidth: '80px' }}
          >
            <i className="fa fa-thumbs-up"></i> {likeCount}
          </button>

          <button
            onClick={() => handleDislike(project.id, false)}
            className="btn"
            style={{ backgroundColor: '#4CAF50', color: 'white', flex: '1', minWidth: '80px' }}
          >
            <i className="fa fa-thumbs-down"></i> {dislikeCount}
          </button>

          <button
            className="btn"
            style={{ backgroundColor: '#4CAF50', color: 'white', flex: '1', minWidth: '80px' }}
            onClick={() => fetchReactions(project.id)}
          >
            Réactions
          </button>

          <button
  className="btn" title="commenter"
  style={{ backgroundColor: '#FF8C00', color: 'white', flex: '1', minWidth: '80px' }}
  onClick={openCommentModal}
>
  <FaRegComment size={15} />
</button>
        </div>

        {/* Modal pour afficher les réactions */}
        {showModal && (
          <div
            className="modal-overlay"
            onClick={() => setShowModal(false)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000
            }}
          >
            <div
              className="modal-content"
              onClick={stopPropagation}
              style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '10px',
                maxWidth: '500px',
                width: '90%',
                maxHeight: '80vh',
                overflow: 'auto',
                position: 'relative'
              }}
            >
              <h3 style={{ color: '#FF8C00' }}>Réactions</h3>
              <button
                className="close-modal"
                onClick={() => setShowModal(false)}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  border: "none",
                  background: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              >
                ×
              </button>
              {likesData && likesData.length > 0 ? (
                <ul style={{ listStyleType: "none", padding: 0 }}>
                  {likesData.map((reaction, index) => (
                    <li key={index} style={{ marginBottom: "10px", padding: "10px", borderBottom: "1px solid #eee" }}>
                      <span style={{ fontWeight: "bold" }}>{reaction.utilisateurNom || "Utilisateur anonyme"}</span> -{" "}
                      {reaction.isLiked ? "👍 " : "👎 "}
                    </li>
                  ))}
                </ul>
              ) : (
                <p>Aucune réaction pour ce projet.</p>
              )}
            </div>
          </div>
        )}

        {/* Modal pour les commentaires */}
        {showCommentModal && (
          <div
            className="modal-overlay"
            onClick={() => setShowCommentModal(false)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000
            }}
          >
            <div
              className="modal-content"
              onClick={stopPropagation}
              style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '10px',
                maxWidth: '500px',
                width: '90%',
                maxHeight: '80vh',
                overflow: 'auto',
              }}
            >
              <h3 style={{ color: '#FF8C00' }}>Commentaires</h3>
              <button
                className="close-modal"
                onClick={() => setShowCommentModal(false)}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  border: "none",
                  background: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              >
                ×
              </button>

              {/* Formulaire de commentaire */}
              <form onSubmit={handleCommentSubmit} style={{ marginBottom: "20px" }}>
                <div className="form-group">
                  <textarea
                    className="form-control"
                    rows="3"
                    placeholder="Ajouter un commentaire..."
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    style={{ marginBottom: "10px", borderRadius: "5px", padding: "10px" }}
                  ></textarea>
                  <button
                    type="submit"
                    className="btn"
                    style={{ backgroundColor: "#FF8C00", color: "white" }}
                  >
                    Commenter
                  </button>
                </div>
              </form>

              {/* Liste des commentaires */}
              <div className="comments-list">
                <h4>Tous les commentaires ({comments.length})</h4>
                {comments && comments.length > 0 ? (
                  <ul style={{ listStyleType: "none", padding: 0 }}>
                    {comments.map((commentItem, index) => (
                      <li key={index} style={{
                        marginBottom: "15px",
                        padding: "10px",
                        borderRadius: "8px",
                        backgroundColor: "#f8f9fa",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                      }}>
                        <div style={{
                          fontWeight: "bold",
                          marginBottom: "5px",
                          color: "#FF8C00"
                        }}>
                          {commentItem.utilisateur && commentItem.utilisateur.nom
                            ? commentItem.utilisateur.nom
                            : commentItem.utilisateurNom
                              ? commentItem.utilisateurNom
                              : "Utilisateur anonyme"}
                        </div>
                        <div style={{
                          padding: "5px 0",
                          fontSize: "15px"
                        }}>{commentItem.message}</div>
                        <div style={{
                          fontSize: "12px",
                          color: "#777",
                          marginTop: "5px",
                          textAlign: "right"
                        }}>

                        </div>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>Aucun commentaire pour ce projet.</p>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default InfoProjet;
